import { InjectionToken, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export enum SingleFilterGuardAction {
  resetSelection,
  skipTabChange,
  continueWithTabChange,
}

export interface SingleFilterGuardEvent {
  currentSelectedIndex: number;
  newSelectedIndex: number;
}

export interface InternalSingleFilterBarGuardI {
  beforeSelectionChange(params?: SingleFilterGuardEvent): Observable<SingleFilterGuardAction>;
}

export const INTERNAL_SINGLE_FILTER_BAR_GUARD_TOKEN = new InjectionToken<InternalSingleFilterBarGuardI>(
  'INTERNAL_SINGLE_FILTER_BAR_GUARD_TOKEN'
);

@Injectable({ providedIn: 'root' })
export class InternalSingleFilterBarGuard implements InternalSingleFilterBarGuardI {
  beforeSelectionChange() {
    return of(SingleFilterGuardAction.continueWithTabChange);
  }
}
